import {debounce} from "lodash";
import store from "@/store";

const save = () => store.commit("base/width", window.innerWidth);

window.addEventListener("resize", debounce(save, 500));

save();
